import { cn } from '@repo/lib/cn';

import { QuestionMarkedLong } from '@/components/features/quiz/question/question-marked/question-long';
import { QuestionBase } from '@/components/features/quiz/question/question-resolver';
import { Textarea } from '@/components/ui/textarea';
import { useQuestionLong } from '@/hooks/questions';

import type { QuestionLongProps } from '.';

export function QuestionLong(questionLongProps: QuestionLongProps) {
  const { question, showMarked } = questionLongProps;

  const { marked, handleInputChange, status, value, exportedUserAnswer } = useQuestionLong(questionLongProps);

  return (
    <QuestionBase content={question.content} type={question.type}>
      <div className="space-y-2">
        <Textarea placeholder="Odpowiedz na pytanie" maxLength={question.maxLength} minLength={question.minLength} value={value} onChange={handleInputChange} disabled={showMarked} className="h-86" />
        <div className="flex flex-col gap-4 sm:flex-row">
          <p className={cn('text-xs tracking-tight', status.className)}>{status.message}</p>
        </div>
      </div>
      <QuestionMarkedLong marked={marked} question={question} answer={exportedUserAnswer} showMarked={showMarked} showQuestion={false} />
    </QuestionBase>
  );
}
